module.exports = __webpack_public_path__ + "static/media/CreateWorkout_Sketch.c4c82b25.png";